import React, { useEffect, useState, useRef, useContext } from "react";
import { useMutation } from "react-query";
import * as moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroller";
import fetcher from "../../../../../dataProvider";
import ParentMessage from "./parent-message";
import MessageReaction from "./message-reaction";
import ObjectIconImg from "../../ObjectIconImg";
import MessageActionButton from "./action";
import MetaProperties from "./meta";
import EditMessage from "./edit-message";
import {
  setChannelMessageList,
  setMessageRefresh,
  setShowAllThreads,
} from "../../../../../redux/actions";
import {
  Link,
  Box,
  Typography,
  Button,
  Modal,
  List,
  ListItem,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  setShowThread,
  setSelectedThread,
  setThreadDetails,
  setUnreadMessageNotifications,
} from "../../../../../redux/slices/community";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import {
  getUnreadMessageList,
  resetLastSeenMessageTimeStamp,
} from "../channel/api";
import UnreadMessagesStrip from "./unreadMessagesStrip";
import socketEvents from "../../../../../constant/socketEvents.js";
import { CommonContext } from "../../../../../../components/helper/commonContext";
import useCountDown from "../../../../../hooks/useCountDown";
import nftLandingCss from "../../../../../../components/NFTLandingPage/style";
import Image from "next/image";

const useStyles = makeStyles((theme) => ({
  threadList: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "0",
    marginBottom: "60px",
    maxHeight: "250px",
    overflow: "auto",
    "& > li": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0",
      padding: "10px",
      background: "#F4F5FD",
      borderRadius: "8px",
      marginBottom: "16px",
      boxShadow:
        "0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802)",
    },
  },
  threadTitle: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginBottom: "7px",
    width: "100%",
    "& img": {
      margin: "0",
    },
    "& h5": {
      fontSize: "14px",
      fontWeight: "600",
      margin: "0 12px 0 5px",
    },
    "& span": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#E14084",
    },
    "@media(max-width:767px)": {
      flexWrap: "wrap",
      alignItems: "start",
      "& h5": {
        maxWidth: "84%",
        wordBreak: "break-word",
      },
      "& span": {
        paddingLeft: "15px",
        marginTop: "7px",
      },
    },
    "@media(max-width:480px)": {
      marginTop: "7px",
      "& h5": {
        marginTop: "7px",
      },
      "& span": {
        marginTop: "7px",
        paddingLeft: "0",
      },
    },
  },
  threadCreatedBy: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    "& img": {
      margin: "0",
    },
    "& h5": {
      color: "#505050",
      fontSize: "12px",
      fontWeight: "600",
      margin: "0 12px 0 5px",
    },
    "& span": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#707174",
      margin: "0 12px 0 0",
    },
    "@media(max-width:767px)": {
      flexWrap: "wrap",
      paddingLeft: "30px",
      wordBreak: "break-word",
      "& h5": {
        marginTop: "7px",
      },
      "& span": {
        marginTop: "7px",
      },
    },
    "@media(max-width:480px)": {
      paddingLeft: "0",
      "& h5": {
        marginLeft: "0",
      },
    },
  },
  DPconnector: {
    top: "33px",
    left: "30px",
    width: "50px",
    position: "absolute",
    borderLeft: "1px solid #e94177",
    borderBottom: "1px solid #e94177",
    borderRadius: "0 0 0 7px",
    bottom: "50px",
  },
  msgOverflowScroll: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "512px",
    background: "#fff",
    margin: "auto",
    padding: "40px 40px",
    borderRadius: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    "& img": {
      zIndex: "2",
      position: "absolute",
      top: "15px",
      right: "15px",
      height: "13px",
      width: "13px",
      cursor: "pointer",
    },
    "&  textarea": {
      resize: "none",
      fontSize: "14px",
      minHight: "150px",
      marginBottom: "15px",
      "&:focus": {
        boxShadow: "none",
        borderColor: "#ced4da",
      },
    },

    "@media(max-width:767px)": {
      width: "90%",
      padding: "15px",
    },
  },
  modalContainer: {
    position: "relative",
    display: "block",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "465px",
    background: "#fff",
    borderRadius: "8px",
    padding: "30px 22px 15px",
    "& h4": {
      fontSize: "20px",
      fontWeight: "600",
      color: "#000",
      width: "100%",
      textAlign: "center",
      marginBottom: "8px",
    },
    "& span": {
      position: "relative",
      display: "block",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "22px",
      textAlign: "center",
      marginBottom: "24px",
    },
    "& img": {
      textAlign: "center !important",
      position: "absolute !important",
      top: "10px !important",
      right: "10px !important",
      cursor: "pointer !important",
    },
    "@media(max-width:480px)": {
      width: "90%",
    },
  },
  modalContainerImg: {
    position: "relative",
    display: "block",
    top: "100px",
    margin: "auto",
    // transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "600px",
    background: "#000",
    borderRadius: "8px",
    // padding: "30px 22px 15px",

    "& img": {
      textAlign: "center",
      position: "relative",
      display: "block",
      margin: "auto",
      cursor: "pointer",
    },
    "@media(max-width:480px)": {
      width: "90%",
    },
  },
  modalContainervideo: {
    position: "relative",
    display: "block",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    background: "#000",
    borderRadius: "8px",

    "& span": {
      position: "relative",
      display: "block",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "22px",
      textAlign: "center",
      marginBottom: "24px",
    },
    "& img": {
      textAlign: "center !important",
      position: "absolute !important",
      top: "10px !important",
      right: "10px !important",
      cursor: "pointer !important",
    },
    "@media(max-width:480px)": {
      width: "90%",
    },
  },
  modalBtnContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& button": {
      position: "relative",
      textAlign: "center",
      display: "block",
      width: "180.5px ",
      maxWidth: "180px",
      padding: "8px 20px",
      height: "44px",
      margin: "0 12px",
      textTransform: "capitalize",
      borderRadius: "8px",
      border: "1px solid transparent",
      fontWeight: "600",
      fontSize: "14px",
    },
  },
  btnCancel: {
    borderColor: "#4f4f4f !important",
    color: "#4f4f4f !important",
  },
  btnDeleteMessgae: {
    border: "none !important",
    background:
      "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    color: "#fff !important",
  },
  reactPlayercss: {
    "& video": {
      transform: "none",
      pointerEvents: "none",
    },
  },
  reactPlayercssvideo: {
    width: "100%",
    "& video": {
      transform: "none",
    },
  },
}));

let lastDt = "";
let showDt = "";
const MessageDetail = ({ item, isMobile }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openImg, setOpenImg] = useState(false);
  const url = "https://www.youtube.com/embed";

  return (
    <>
      {item?.type === "text" && (
        <>
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            className="line-break-mark"
          >
            {item?.text}
          </ReactMarkdown>
          {item?.attachments.length > 0 &&
            item?.attachments?.[0]?.mime.includes("image") && (
              <Box
                component="img"
                style={
                  isMobile
                    ? {
                        width: "243px",
                        height: "330px",
                        objectFit: "contain",
                        cursor: "pointer",
                      }
                    : {
                        width: "50%",
                        height: "330px",
                        objectFit: "contain",
                        cursor: "pointer",
                      }
                }
                src={item?.attachments?.[0]?.url}
                onClick={() => setOpenImg(true)}
              />
            )}
          {item?.attachments.length > 0 &&
            item?.attachments?.[0]?.mime.includes("video") && (
              <Box
                className={classes.reactPlayercss}
                onClick={() => setOpen(true)}
                style={{ cursor: "pointer" }}
              >
                <video
                  width={isMobile ? "100%" : "750"}
                  height={isMobile ? "300" : "500"}
                  style={{ objectFit: "contain" }}
                  controls
                >
                  <source
                    src={item?.attachments?.[0]?.url}
                    type={item?.attachments?.[0]?.mime.includes("video")}
                  />
                </video>
              </Box>
            )}
        </>
      )}

      {item?.type === "livestream" && (
        <div style={{ height: "100%", width: "100%" }}>
          <iframe
            height="660"
            width="1000"
            src={url + `/${item?.text}?autoplay=1&mute=1`}
          ></iframe>
        </div>
      )}

      {item?.metaProperties && item?.metaProperties?.length > 0 && (
        <MetaProperties meta={item?.metaProperties} isMobile={isMobile} />
      )}
      {item?.type === "gif" && (
        <img src={item?.text} className="gif_msg" alt="gif message" />
      )}
      {item?.reactionsAggregated && item?.reactionsAggregated.length > 0 && (
        <MessageReaction
          reaction={item?.reactionsAggregated}
          msgId={item?._id}
        />
      )}

      {/* image  popup display */}
      <Modal
        open={openImg}
        onClose={() => setOpenImg(false)}
        disableScrollLock={true}
      >
        <Box className={classes.modalContainerImg}>
          <Box component="img" src={item?.attachments?.[0]?.url} />
        </Box>
      </Modal>

      {/* Video popup display */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        disableScrollLock={true}
      >
        <Box className={classes.modalContainervideo}>
          <Box className={classes.reactPlayercssvideo}>
            <video
              width="100%"
              style={{ objectFit: "contain" }}
              controls
              autoPlay
            >
              <source
                src={item?.attachments?.[0]?.url}
                type={item?.attachments?.[0]?.mime.includes("video")}
              />
            </video>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
const CommunityMessageList = ({ user, isMobile, community, channel, goTo }) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const itemRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [deleteMessageindex, setDeleteMessageindex] = useState(0);
  const [deletemessageArray, setDeletemessageArray] = useState([]);

  const [parentRef, setParentRef] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [messageList, setMessageList] = useState([]);
  const [currentChannel, setCurrentChannel] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingScroll, setLoadingScroll] = useState(true);
  const [totalRecord, setTotalRecord] = useState(0);
  const [newMessageToChannel, setNewMessageToChannel] = useState(null);
  const [show, setShow] = useState(false);

  // auto refresh show unseen messages
  const [lastSeenMessage, setLastSeenMessage] = useState(null);
  const [unseenMessageList, setUnseenMessageList] = useState([]);
  const [displayList, setDisplayList] = useState([]);

  // lastSeenMessageTimeStamp
  const [unreadMesageCount, setUnreadMessageCount] = useState(0);
  const [unreadMessagesList, setUnreadMessagesList] = useState([]);

  const currentChannelCommunityState = useSelector(
    (state) => state.community.currentChannel
  );
  const { userData } = useSelector((state) => state.user);
  const currentChannelMessageState = useSelector(
    (state) => state.community.channelMessageList
  );

  const currentChannels = useSelector((state) => state.community.channels);
  const messageRefreshState = useSelector((state) => state.community.refresh);

  const { unreadMessageNotifications } = useSelector(
    (state) => state.community
  );
  const commonContext = useContext(CommonContext);
  const socket = commonContext.socket;

  const { mutate: getMessage } = useMutation(({ id, page }) =>
    fetcher.get(`/v1/message?channelId=${id}&page=${page}&updateLastSeen=true`)
  );
  const { mutate: deleteMessage } = useMutation((id) =>
    fetcher.delete(`/v1/message/${id}`, {})
  );
  const { mutate: addMessageReaction } = useMutation(({ id, data }) =>
    fetcher.post(`/v1/message/${id}/reaction`, data)
  );
  const { mutate: editMessage } = useMutation(({ id, data }) =>
    fetcher.patch(`/v1/message/${id}`, data)
  );

  const { mutate: adminBlockUser } = useMutation((id) =>
    fetcher.get(`/v1/user/${id}/admin-block-user`)
  );

  //request body for pinned message
  let pinnedObj = {
    channelId: channel,
    isPinned: true,
  };
  const { mutate: pinnedMessage } = useMutation((data) =>
    fetcher.post(`/v1/message/${data.id}/pin`, {
      ...pinnedObj,
      pinPosition: data.position,
    })
  );

  const { mutate: pinnedAnnouncementMessage } = useMutation((data) =>
    fetcher.post(`/v1/announcement/`, {
      text: data.text,
      type: data.type,
    })
  );

  const handlePinnedMsg = (index, item, position) => {
    pinnedMessage(
      { id: item?._id, position },
      {
        onSuccess: (res) => {
          dispatch(setMessageRefresh(true));
          refreshData();
        },
        onError: () => {},
      }
    );
  };

  const handlePinnedAnnouncement = (e, item) => {
    pinnedAnnouncementMessage(
      { text: item?.text, type: "announcement" },
      {
        onSuccess: (res) => {
          console.log("print response handlePinnedAnnouncement", res);
        },
        onError: () => {},
      }
    );
  };

  const { mutate: reportMessage } = useMutation((data) =>
    fetcher.post(`/v1/message/${data.id}/report`, data?.reportMessageObj)
  );

  const [open1, setOpen1] = useState(false);
  const [flagmessage, setFlagmessage] = useState();
  const [flagmessageindex, setFlagmessageindex] = useState(0);
  const [flgmessageArray, setFlagmessageArray] = useState([]);

  const handleEnter = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      setFlagmessage("");
      handleClose1(flagmessageindex, flgmessageArray);
    }
  };

  const handleOpen1 = (index, item) => {
    setFlagmessageindex(index);
    setFlagmessageArray(item);
    setOpen1(true);
  };

  const handleClose1 = (index, item) => {
    handleMessageReport(index, item);
    setOpen1(false);
  };

  const handleMessageReport = (index, item) => {
    setOpen1(true);
    console.log("Message reported" + flagmessage);
    let reportMessageObj = {
      comment: flagmessage,
    };
    reportMessage(
      { id: item?._id, reportMessageObj: reportMessageObj },
      {
        onSuccess: (res) => {
          refreshData();
          setFlagmessage("");
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  };

  useEffect(() => {
    if (messageRefreshState) {
      refreshData();
    }
  }, [messageRefreshState]);

  useEffect(() => {
    if (currentChannelMessageState) {
      setMessageList([...currentChannelMessageState, ...messageList]);
      setLoadingScroll(false);
    }
  }, [currentChannelMessageState]);

  useEffect(() => {
    if (!loadingScroll) {
      setLoading(false);
    }
  }, [loadingScroll]);

  const [loadingUnreadList, setLoadingUnreadList] = useState(true);

  useEffect(() => {
    if (itemRef?.current && !loadingUnreadList) {
      setTimeout(() => {
        if (itemRef?.current) itemRef?.current?.scrollIntoView(false);
      }, 200);
    }
  }, [itemRef?.current, loadingUnreadList]);

  useEffect(() => {
    console.log("currentChannelCommunityState", currentChannelCommunityState);
    if (currentChannelCommunityState) {
      setUnreadMessagesList([]);
      setMessageList([]);
      setUnreadMessageCount(0);
      setUnseenMessageList([]);
      setDisplayList([]);
      setLastSeenMessage(null);
      setCurrentChannel(currentChannelCommunityState);
      setLoadingUnreadList(true);
      updateUnreadMessageList(currentChannelCommunityState?._id);
      getMessageListData(currentChannelCommunityState, 0);
    }
  }, [currentChannelCommunityState]);

  useEffect(() => {
    console.log("socket changing inside emits", socket?.id, socket?.connected);
    if (currentChannelCommunityState) {
      if (socket != null) {
        console.log("socket subscribing to ", socket.id, socket.connected);
        socket.emit(socketEvents.SUBSCRIBE_TO_CHANNEL, {
          channelId: currentChannelCommunityState?._id,
        });
        console.log("socket subscribed : ", socket.id, socket.connected);
      }
    }
    return () => {
      if (currentChannelCommunityState) {
        if (socket != null) {
          socket.emit(socketEvents.UNSUBSCRIBE_TO_CHANNEL, {
            channelId: currentChannelCommunityState?._id,
          });
          console.log("socket unsubscribed : ", socket.id);
        }
      }
    };
  }, [currentChannelCommunityState, commonContext.socketId]);

  const refreshData = () => {
    setMessageList([]);
    getMessageListData(currentChannel, 0);
    dispatch(setMessageRefresh(false));
  };
  const getMessageListData = (item, page) => {
    getMessage(
      { id: item?._id, page: page },
      {
        onSuccess: (res) => {
          setCurrentPage(page + 1);
          setTotalRecord(res.totalResults);
          dispatch(setChannelMessageList(res.result.reverse()));
        },
        onError: (err) => {
          setLoading(false);
        },
      }
    );
  };
  const handleNext = () => {
    if (
      !loading &&
      messageList.length > 0 &&
      totalRecord > messageList.length
    ) {
      setLoading(true);
      setLoadingScroll(true);
      getMessageListData(currentChannel, currentPage);
    }
  };

  const handleOpen = (index, item) => {
    setDeleteMessageindex(index);
    setDeletemessageArray(item);
    setOpen(true);
  };

  const handleClose = (index, item) => {
    handleDelete(index, item);
    setOpen(false);
  };

  const handleDelete = (index, item) => {
    setOpen(true);
    deleteMessage(item._id, {
      onSuccess: () => {
        displayList.splice(index, 1);
      },
      onError: () => {},
    });
    // }
  };
  const handleEditSubmit = (index, data) => {
    editMessage(
      { id: selectedMessage._id, data: data },
      {
        onSuccess: () => {
          let _msgList = messageList;
          _msgList[index] = { ...selectedMessage, ...{ text: data.text } };
          setMessageList(_msgList);
          setSelectedMessage(null);
          // refreshData();
        },
        onError: () => {
          setSelectedMessage(null);
          // refreshData();
        },
      }
    );
  };
  const handleReaction = (e, item) => {
    if (item?.reactionsAggregated.length < 10) {
      addMessageReaction(
        { id: item._id, data: { emoji: e?.unified } },
        {
          onSuccess: () => {
            // refreshData();
          },
          onError: () => {},
        }
      );
    } else {
      setShow(true);
    }
  };

  // admin block user

  const handleUserBlock = (index, item) => {
    adminBlockUser(item?.user?._id, {
      onSuccess: (res) => {
        console.log("Prinmt response ", res);
      },
      onError: () => {},
    });
  };

  const openThreadSideView = (item) => {
    dispatch(setThreadDetails(item));
    dispatch(setSelectedThread(item?.meta?._id));
    dispatch(setShowThread(true));
    if (isMobile) {
      goTo("member");
    }
  };

  // Adding socket listeners
  useEffect(() => {
    if (socket != null && socket.connected) {
      socket.on(socketEvents.GET_MESSAGE, (messageList) => {
        setNewMessageToChannel(messageList[0]);
      });
    }

    return () => {
      if (socket != null && socket.connected) {
        socket.off(socketEvents.GET_MESSAGE);
      }
    };
  }, [commonContext?.socketId]);

  useEffect(() => {
    if (newMessageToChannel != null) {
      let senderId = newMessageToChannel?.user?._id;
      if (userData?.id == senderId) {
        setMessageList([
          ...displayList,
          ...unseenMessageList.reverse(),
          newMessageToChannel,
        ]);
        setUnseenMessageList([]);
        setUnreadMessagesList([]);

        setTimeout(() => {
          if (itemRef.current) itemRef.current.scrollIntoView();
        }, 500);
      } else {
        setUnseenMessageList((prev) => [newMessageToChannel, ...prev]);
      }
    }
  }, [newMessageToChannel]);

  const viewUnseenMessages = () => {
    setMessageList([...displayList, ...unseenMessageList.reverse()]);
    setUnseenMessageList([]);
    if (itemRef && itemRef?.current) {
      setTimeout(() => {
        if (itemRef.current) itemRef.current.scrollIntoView();
      }, 500);
    }
  };

  const getMessageSubstr = (msg) => {
    if (typeof msg != "undefined") {
      if (isMobile) {
        let len = 15;
        if (msg.length > len) {
          let msgTextArr = msg.substring(0, len).lastIndexOf(" ");
          return (
            msg.substring(0, msgTextArr >= 0 ? msgTextArr + 1 : len) + "..."
          );
        } else {
          return msg;
        }
      } else {
        let len = 110;
        if (msg.length > len) {
          let msgTextArr = msg.substring(0, len).lastIndexOf(" ");
          return (
            msg.substring(0, msgTextArr >= 0 ? msgTextArr + 1 : len) + "..."
          );
        } else {
          return msg;
        }
      }
    } else return msg;
  };

  const updateUnreadMessageList = async (channelId) => {
    if (channelId) {
      let response = await getUnreadMessageList(channelId);
      if (response?.length) {
        setUnreadMessagesList(response.reverse());
        setUnreadMessageCount(response?.length);
      }

      setTimeout(() => {
        setLoadingUnreadList(false);
      }, 100);
    }
  };

  const removeDuplicates = (list) => {
    let result = [];
    list.map((item) => {
      if (result.indexOf(item) == -1) {
        result.push(item);
      }
    });
    return result;
  };

  useEffect(() => {
    let finalList = removeDuplicates([...messageList, ...unreadMessagesList]);
    setDisplayList(finalList);
  }, [unreadMessagesList, messageList]);

  const resetLastSeenTimeStamp = async (channelId, timeStamp) => {
    if (channelId && timeStamp) {
      let response = await resetLastSeenMessageTimeStamp(channelId, timeStamp);
      if (response?.lastSeenMessageTimestamp) {
        setUnreadMessageCount(0);
      }
    }
  };

  useEffect(() => {
    if (unreadMessagesList.length && !loadingUnreadList) {
      let element = window.document.getElementById("scrollableDiv");

      if (
        Math.ceil(element.offsetHeight, +element.scrollTop) >=
        Math.floor(element.scrollHeight)
      ) {
        resetLastSeenTimeStamp(
          currentChannelCommunityState?._id,
          unreadMessagesList[unreadMessagesList?.length - 1]?.createdAt
        );
      }
    }
  }, [unreadMessagesList && loadingUnreadList]);

  const [pinUnreadStrip, setPinUnreadStrip] = useState(false);

  // update last seen message if message List changes
  useEffect(() => {
    if (displayList.length) {
      setLastSeenMessage(displayList[displayList.length - 1]);
    }
  }, [displayList]);

  // update the channels unread count in redux
  useEffect(() => {
    if (unreadMessageNotifications?.length) {
      let unreadsList = [...unreadMessageNotifications];
      const unreadItem = unreadsList.filter(
        (item) => item?.channelId == currentChannelCommunityState?._id
      );
      if (unreadItem?.length) {
        let indexOfChannelItem = unreadsList.indexOf(unreadItem[0]);
        if (indexOfChannelItem >= 0) {
          unreadsList[indexOfChannelItem] = {
            ...unreadItem[0],
            count: unreadMesageCount,
          };
          dispatch(setUnreadMessageNotifications(unreadsList));
        }
      }
    }
  }, [unreadMesageCount]);

  const jumpToPresent = () => {
    setMessageList([...displayList]);
    setUnreadMessagesList([]);
    setUnreadMessageCount(0);

    if (itemRef && itemRef?.current) {
      setTimeout(() => {
        if (itemRef.current) itemRef.current.scrollIntoView(false);
      }, 200);
    }
  };

  const handleUserClickOrKeyPress = () => {
    resetLastSeenTimeStamp(
      currentChannelCommunityState?._id,
      displayList[displayList?.length - 1]?.createdAt
    );
  };

  useEffect(() => {
    let element = document.getElementById("scrollableDiv");
    let value = false;
    if (unreadMesageCount <= 5 && unreadMesageCount > 0) {
      element.addEventListener("click", handleUserClickOrKeyPress);
      element.addEventListener("keydown", handleUserClickOrKeyPress);
      value = true;
    }
    return () => {
      if (value) {
        element.removeEventListener("click", handleUserClickOrKeyPress);
        element.removeEventListener("keydown", handleUserClickOrKeyPress);
      }
    };
  }, [unreadMesageCount]);

  const hasLiveStreamEnded = (endDate) => {
    const today = new Date();
    const endsAt = new Date(endDate);
    const todayInGmt = new Date(today.toUTCString());
    if (endsAt.getTime() - todayInGmt.getTime() < 0) {
      return true;
    } else {
      return false;
    }
  };

  const {
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = useCountDown(currentChannelCommunityState?.livedate);

  const isLiveStreamEnded = hasLiveStreamEnded(
    currentChannelCommunityState?.livedate
  );

  var isEventLive;

  const checkThreadeventLive = (item) => {
    if (item?.threadDetails?.message?.totalCount == 1) {
      if (item?.threadDetails?.message?.lastMessage?.type == "predictor") {
        isEventLive = hasLiveStreamEnded(
          item?.threadDetails?.message?.lastMessage?.predictorEventDate
        );

        return isEventLive;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const ThreadMessageComponent = ({ item, index }) => {
    if (!checkThreadeventLive(item)) {
      return null;
    }
    return (
      <div
        style={{
          background:
            currentChannel?.name == "Announcements" ? "#fffaef" : item?.bgColor,
        }}
        className={
          currentChannel?.name != "Announcements"
            ? "message_wrap poll_message_wrapper message_wrap_hover"
            : "message_wrap poll_message_wrapper message_wrap_hover_new"
        }
      >
        <div className="poll-container">
          <div className="user_action_info">
            <div
              className="user_info"
              ref={
                unreadMesageCount &&
                index == messageList.length &&
                !loadingUnreadList
                  ? itemRef
                  : null
              }
            >
              <ObjectIconImg
                profilePic={item?.user?.profilePic}
                name={item?.user?.name}
                outerClass={"user_img"}
                innerClass={"user_img_inner"}
              />
              {(!selectedMessage || selectedMessage._id != item._id) && (
                <MessageActionButton
                  item={item}
                  user={user}
                  handleDelete={(e) => {
                    handleDelete(index, item);
                  }}
                  handleReaction={(e) => {
                    handleReaction(e, item);
                  }}
                  handleEdit={() => {
                    setSelectedMessage(item);
                  }}
                  handlePinnedMsg={(position) => {
                    handlePinnedMsg(index, item, position);
                  }}
                  handleMessageReport1={(e) => {
                    handleOpen1(index, item);
                  }}
                  handlePinnedAnnouncement={(e) => {
                    handlePinnedAnnouncement(e, item);
                  }}
                  handleUserblock={(e) => {
                    handleUserBlock(index, item);
                  }}
                  isMobile={isMobile}
                />
              )}
            </div>
          </div>
          <div className="poll-creator">
            <span className={classes.DPconnector}></span>
            <p>
              <span>{item?.user?.name}</span> started a new thread :{" "}
              <strong>
                {" "}
                {item?.threadDetails?.meta?.name?.length > 40
                  ? item?.threadDetails?.meta?.name?.substring(0, 0) + "..."
                  : item?.threadDetails?.meta?.name}
              </strong>{" "}
              <Typography
                onClick={() => {
                  dispatch(setShowAllThreads(true));
                }}
                style={{ cursor: "pointer", color: "blue" }}
              >
                See all Threads
              </Typography>
            </p>
            {item?.type === "text" &&
              item?.text != item?.threadDetails?.meta?.name && (
                <p>{getMessageSubstr(item?.text.replaceAll("***", ""))}</p>
              )}
            <small>{moment(item?.createdAt).format("HH:MM A")}</small>

            <List className={classes.threadList}>
              <ListItem>
                <Box>
                  <Box
                    className={classes.threadTitle}
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      openThreadSideView(item?.threadDetails);
                    }}
                  >
                    <Box
                      component="img"
                      src="/images/community/hashChat.svg"
                      width="18"
                      height="18"
                      alt="Thread icon"
                    />
                    <Typography variant="h5">
                      {item?.threadDetails?.meta?.name}
                    </Typography>
                    <Typography variant="span">
                      <Link href="#" style={{ textDecoration: "none" }}>
                        {item?.threadDetails?.message?.totalCount ? (
                          <span>
                            {item?.threadDetails?.message?.totalCount}{" "}
                            {item?.threadDetails?.message?.totalCount > 1
                              ? "Messages "
                              : "Message "}
                          </span>
                        ) : (
                          <></>
                        )}
                        <Box
                          component="img"
                          src="/images/community/angle-arrow-right.svg"
                          width="10px"
                          height="10px"
                          alt="images"
                        />
                      </Link>
                    </Typography>
                  </Box>
                  {item?.threadDetails?.message?.totalCount ? (
                    <Box className={classes.threadCreatedBy}>
                      <Typography variant="span">
                        {item?.threadDetails?.message?.lastMessage?.user?.name}
                      </Typography>
                      <Typography variant="h5">
                        {getMessageSubstr(
                          item?.threadDetails?.message?.lastMessage?.text.replaceAll(
                            "***",
                            ""
                          )
                        )}
                      </Typography>
                      <Typography variant="h5">
                        {moment(
                          item?.threadDetails?.message?.lastMessage?.createdAt
                        ).format("HH:MM A")}
                      </Typography>
                    </Box>
                  ) : (
                    <></>
                  )}
                </Box>
              </ListItem>
            </List>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="message_list">
      {currentChannelCommunityState?.type != "stage" ? (
        <div
          id="scrollableDiv"
          className="scroll-content"
          ref={(ref) => setParentRef(ref)}
          onScroll={(event) => {
            // var elementTop = 0;
            // if (unreadMesageCount)
            //   elementTop = document.getElementById(
            //     "unreadMessageStripBox"
            //   ).offsetTop;
            // let divTop = document.getElementById("scrollableDiv").offsetTop;
            if (
              Math.ceil(event.target.offsetHeight + event.target.scrollTop) >=
                Math.floor(event.target.scrollHeight) &&
              !loadingUnreadList
            ) {
              if (unreadMesageCount >= 0) {
                resetLastSeenTimeStamp(
                  currentChannelCommunityState?._id,
                  displayList[displayList?.length - 1]?.createdAt
                );
              }
            }
          }}
        >
          {/* <Box sx={{ position: "absolute", width: "100%" }}>
          <UnreadMessagesStrip unreadMesageCount={unreadMesageCount} />
        </Box> */}

          <InfiniteScroll
            pageStart={currentPage - 1}
            loadMore={handleNext}
            hasMore={totalRecord > messageList.length}
            loader={
              <div className="loader" key={0}>
                Loading ...
              </div>
            }
            isReverse={true}
            useWindow={false}
            threshold={250}
            getScrollParent={() => parentRef}
          >
            {displayList.map((item, index) => {
              lastDt = showDt;
              showDt = moment(item?.createdAt).calendar(null, {
                lastDay: "[Yesterday]",
                sameDay: "[Today]",
                nextDay: "[Tomorrow]",
                lastWeek: "LL",
                sameElse: "LL",
              });
              return (
                <div key={index}>
                  {lastDt != showDt && (
                    <div
                      key={showDt}
                      style={{
                        background:
                          currentChannel?.name == "Announcements"
                            ? "#fffaef"
                            : "",
                      }}
                      className="show_date"
                    >
                      {showDt}
                    </div>
                  )}
                  {unreadMesageCount &&
                  index == messageList?.length &&
                  !loadingUnreadList ? (
                    <Box id={"unreadMessageStripBox"}>
                      <UnreadMessagesStrip
                        unreadMesageCount={unreadMesageCount}
                        onClickJumpToPresent={jumpToPresent}
                        isMobile={isMobile}
                      />
                    </Box>
                  ) : (
                    <></>
                  )}

                  {!item?.isThread ? (
                    <>
                      <div
                        style={{
                          background:
                            currentChannel?.name == "Announcements"
                              ? "#fffaef"
                              : item?.bgColor,
                        }}
                        className={
                          currentChannel?.name != "Announcements"
                            ? "message_wrap poll_message_wrapper message_wrap_hover"
                            : "message_wrap poll_message_wrapper message_wrap_hover_new"
                        }
                        id={`item${index}`}
                        key={`msg${index}`}
                        ref={
                          !unreadMesageCount &&
                          index == displayList.length - 1 &&
                          !loadingUnreadList
                            ? itemRef
                            : null
                        }
                      >
                        <ParentMessage item={item} />

                        <div className="poll-container">
                          <div className="user_action_info">
                            <div
                              className="user_info"
                              ref={
                                unreadMesageCount &&
                                index == messageList.length &&
                                !loadingUnreadList
                                  ? itemRef
                                  : null
                              }
                            >
                              <ObjectIconImg
                                profilePic={item?.user?.profilePic}
                                backgroundColor={
                                  item?.user?.profileBgColor
                                    ? item?.user?.profileBgColor + "!important"
                                    : "#e14084"
                                }
                                name={item?.user?.name}
                                outerClass={"user_img"}
                                innerClass={"user_img_inner"}
                              />
                            </div>

                            {(!selectedMessage ||
                              selectedMessage._id != item._id) && (
                              <MessageActionButton
                                item={item}
                                user={user}
                                handleDelete={(e) => {
                                  handleOpen(index, item);
                                  // handleDelete(index, item);
                                }}
                                handleReaction={(e) => {
                                  handleReaction(e, item);
                                }}
                                handleEdit={(e) => {
                                  setSelectedMessage(item);
                                }}
                                handlePinnedMsg={(position) => {
                                  handlePinnedMsg(index, item, position);
                                }}
                                handleMessageReport1={(e) => {
                                  handleOpen1(index, item);
                                }}
                                handlePinnedAnnouncement={(e) => {
                                  handlePinnedAnnouncement(e, item);
                                }}
                                handleUserblock={(e) => {
                                  handleUserBlock(index, item);
                                }}
                                isMobile={isMobile}
                              />
                            )}
                          </div>
                          <div className="poll-creator">
                            <div className="user_name_dt">
                              <p className="user_name">
                                <Box
                                  sx={{
                                    flexDirection: "row",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    component="strong"
                                    style={{
                                      color:
                                        item?.user?.role == "admin"
                                          ? "blue"
                                          : "",
                                    }}
                                  >
                                    <b>{item?.user?.name}</b>
                                  </Typography>

                                  <small
                                    className="user_dt"
                                    style={{ marginLeft: "15px" }}
                                  >
                                    {moment(item?.createdAt).fromNow()}
                                  </small>
                                </Box>
                              </p>
                              {selectedMessage &&
                              selectedMessage._id == item._id ? (
                                <EditMessage
                                  item={item}
                                  handleCancel={() => {
                                    setSelectedMessage(null);
                                  }}
                                  handleEditSubmit={(e) => {
                                    handleEditSubmit(index, e);
                                  }}
                                />
                              ) : (
                                <div className="message-detail">
                                  <MessageDetail
                                    item={item}
                                    isMobile={isMobile}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <ThreadMessageComponent item={item} index={index} />
                  )}
                </div>
              );
            })}
          </InfiniteScroll>
          {unseenMessageList.length ? (
            <Box
              sx={{
                position: "relative",
                bottom: "0px",
                left: "0px",
                width: "100%",
                height: "34px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                display: "flex",
                background: "#ddd",
                padding: "1px 0px 1px 0px ",
                opacity: 1,
                zIndex: 1,
              }}
              onClick={() => {
                viewUnseenMessages();
              }}
              className="strip_background"
            >
              <Box
                style={{
                  width: "100%",
                  background: "#fff",
                  color: "#E14084",
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "15px",
                  height: "32px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <span>
                  You have{" "}
                  {unseenMessageList.length > 100
                    ? "100+"
                    : unseenMessageList.length}{" "}
                  new messages
                </span>
              </Box>
            </Box>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div
          id="scrollableDiv"
          className="stage_scroll-content"
          ref={(ref) => setParentRef(ref)}
          onScroll={(event) => {
            if (
              Math.ceil(event.target.offsetHeight + event.target.scrollTop) >=
                Math.floor(event.target.scrollHeight) &&
              !loadingUnreadList
            ) {
              if (unreadMesageCount >= 0) {
                resetLastSeenTimeStamp(
                  currentChannelCommunityState?._id,
                  displayList[displayList?.length - 1]?.createdAt
                );
              }
            }
          }}
        >
          <div className="stage_sidebar_streamyard_video">
            <div>
              {isLiveStreamEnded ? (
                <>
                  <iframe
                    src={`https://www.youtube.com/embed/${currentChannelCommunityState?.youtube_embed_code}?autoplay=1&mute=1`}
                    frameBorder="0"
                    allow="autoplay"
                    allowFullScreen
                  ></iframe>
                </>
              ) : (
                <>
                  <Box
                    className="stage_countdown_timer"
                    style={{
                      position: "relative",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <Table
                      className="stage_countdown_timer_table"
                      style={{ borderRadius: "8px", width: "90%" }}
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell align="center">
                            <Typography variant="h4">{days}</Typography>
                            <Typography component="small">Days</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography
                              component="small"
                              style={{
                                fontSize: "35px",
                                fontWeight: "400",
                                position: "relative",
                                top: "-14px",
                              }}
                            >
                              :
                            </Typography>
                          </TableCell>

                          <TableCell align="center">
                            <Typography variant="h4">{hours}</Typography>
                            <Typography component="small">Hours</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography
                              component="small"
                              style={{
                                fontSize: "35px",
                                fontWeight: "400",
                                position: "relative",
                                top: "-14px",
                              }}
                            >
                              :
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="h4">{minutes}</Typography>
                            <Typography component="small">Min</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography
                              component="small"
                              style={{
                                fontSize: "35px",
                                fontWeight: "400",
                                position: "relative",
                                top: "-14px",
                              }}
                            >
                              :
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="h4">{seconds}</Typography>
                            <Typography component="small">Sec</Typography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </>
              )}
            </div>
          </div>
          <div className="stage_message_list_container">
            <InfiniteScroll
              pageStart={currentPage - 1}
              loadMore={handleNext}
              hasMore={totalRecord > messageList.length}
              loader={
                <div className="loader" key={0}>
                  Loading ...
                </div>
              }
              isReverse={true}
              useWindow={false}
              threshold={250}
              getScrollParent={() => parentRef}
            >
              {displayList.map((item, index) => {
                lastDt = showDt;
                showDt = moment(item?.createdAt).calendar(null, {
                  lastDay: "[Yesterday]",
                  sameDay: "[Today]",
                  nextDay: "[Tomorrow]",
                  lastWeek: "LL",
                  sameElse: "LL",
                });
                return (
                  <div key={index}>
                    {lastDt != showDt && (
                      <div
                        key={showDt}
                        style={{
                          background: "#fff",
                        }}
                        className="show_date"
                      >
                        {showDt}
                      </div>
                    )}
                    {unreadMesageCount &&
                    index == messageList?.length &&
                    !loadingUnreadList ? (
                      <Box id={"unreadMessageStripBox"}>
                        <UnreadMessagesStrip
                          unreadMesageCount={unreadMesageCount}
                          onClickJumpToPresent={jumpToPresent}
                          isMobile={isMobile}
                        />
                      </Box>
                    ) : (
                      <></>
                    )}

                    <div
                      style={{
                        background: "#fff",
                      }}
                      className={
                        currentChannel?.type != "stage"
                          ? "message_wrap poll_message_wrapper message_wrap_hover"
                          : "message_wrap poll_message_wrapper message_wrap_hover_new"
                      }
                      id={`item${index}`}
                      key={`msg${index}`}
                      ref={
                        !unreadMesageCount &&
                        index == displayList.length - 1 &&
                        !loadingUnreadList
                          ? itemRef
                          : null
                      }
                    >
                      <ParentMessage item={item} />
                      <div className="poll-container">
                        <div className="user_action_info">
                          <div
                            className="user_info"
                            ref={
                              unreadMesageCount &&
                              index == messageList.length &&
                              !loadingUnreadList
                                ? itemRef
                                : null
                            }
                          >
                            <ObjectIconImg
                              profilePic={item?.user?.profilePic}
                              backgroundColor={
                                item?.user?.profileBgColor
                                  ? item?.user?.profileBgColor + "!important"
                                  : "#e14084"
                              }
                              name={item?.user?.name}
                              outerClass={"user_img"}
                              innerClass={"user_img_inner"}
                            />
                          </div>

                          {(!selectedMessage ||
                            selectedMessage._id != item._id) && (
                            <MessageActionButton
                              item={item}
                              user={user}
                              handleDelete={(e) => {
                                handleOpen(index, item);
                                // handleDelete(index, item);
                              }}
                              handleReaction={(e) => {
                                handleReaction(e, item);
                              }}
                              handleEdit={(e) => {
                                setSelectedMessage(item);
                              }}
                              handlePinnedMsg={(position) => {
                                handlePinnedMsg(index, item, position);
                              }}
                              handleMessageReport1={(e) => {
                                handleOpen1(index, item);
                              }}
                              handlePinnedAnnouncement={(e) => {
                                handlePinnedAnnouncement(e, item);
                              }}
                              handleUserblock={(e) => {
                                handleUserBlock(index, item);
                              }}
                              isMobile={isMobile}
                            />
                          )}
                        </div>
                        <div className="poll-creator">
                          <div className="user_name_dt">
                            <p className="user_name">
                              <Box
                                sx={{
                                  flexDirection: "row",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <b>{item?.user?.name}</b>
                                <small
                                  className="user_dt"
                                  style={{ marginLeft: "15px" }}
                                >
                                  {moment(item?.createdAt).fromNow()}
                                </small>
                              </Box>
                            </p>
                            {selectedMessage &&
                            selectedMessage._id == item._id ? (
                              <EditMessage
                                item={item}
                                handleCancel={() => {
                                  setSelectedMessage(null);
                                }}
                                handleEditSubmit={(e) => {
                                  handleEditSubmit(index, e);
                                }}
                              />
                            ) : (
                              <div className="message-detail">
                                <MessageDetail
                                  item={item}
                                  isMobile={isMobile}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </InfiniteScroll>
            {unseenMessageList.length ? (
              <Box
                sx={{
                  position: "relative",
                  bottom: "0px",
                  left: "0px",
                  width: "100%",
                  height: "34px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  display: "flex",
                  background: "#ddd",
                  padding: "1px 0px 1px 0px ",
                  opacity: 1,
                  zIndex: 1,
                }}
                onClick={() => {
                  viewUnseenMessages();
                }}
                className="strip_background"
              >
                <Box
                  style={{
                    width: "100%",
                    background: "#fff",
                    color: "#E14084",
                    fontWeight: "400",
                    fontSize: "12px",
                    lineHeight: "15px",
                    height: "32px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <span>
                    You have{" "}
                    {unseenMessageList.length > 100
                      ? "100+"
                      : unseenMessageList.length}{" "}
                    new messages
                  </span>
                </Box>
              </Box>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
      <Modal open={open1} disableScrollLock={true}>
        <Box className={classes.msgOverflowScroll}>
          <Box
            component="img"
            src="/images/community/modal-close.svg"
            onClick={() => handleClose1(flagmessageindex, flgmessageArray)}
          />
          <Typography variant="p">
            Please enter feedback for reported Message Content
          </Typography>

          <textarea
            id="flag_content"
            Rows={3}
            placeholder={"Type a Comment"}
            onChange={(e) => {
              setFlagmessage(e.target.value);
            }}
            onKeyPress={handleEnter}
            value={flagmessage}
            className="form-control"
          ></textarea>
          <Button
            variant="outlined"
            style={{ border: "red" }}
            onClick={() => handleClose1(flagmessageindex, flgmessageArray)}
          >
            Submit
          </Button>
        </Box>
      </Modal>

      {/* Delte message Popup */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        disableScrollLock={true}
      >
        <Box className={classes.modalContainer}>
          <Box
            component="img"
            src="/images/payment/popup-close.svg"
            sx={classes.btnClose}
            width="24"
            height="24"
            onClick={() => setOpen(false)}
          />
          <Typography variant="h4">Sure you want to delete?</Typography>
          <Typography component="span">
            This message will be deleted immediately. You can’t undo this
            action.
          </Typography>

          <Box className={classes.modalBtnContainer}>
            <Button
              onClick={() => setOpen(false)}
              className={classes.btnCancel}
            >
              Cancel
            </Button>
            <Button
              className={classes.btnDeleteMessgae}
              contained="solid"
              onClick={() =>
                handleClose(deleteMessageindex, deletemessageArray)
              }
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* reaction limit popup */}
      <Modal
        open={show}
        onClose={() => setShow(false)}
        aria-labelledby="How It Works"
        aria-describedby="modal-modal-description"
      >
        <Box sx={nftLandingCss.modalreactionContainer}>
          <Box sx={nftLandingCss.modalHeader}>
            <Typography variant="h4" sx={nftLandingCss.modalreactionTitle}>
              WE APPRECIATE THE ENTHUSIASM, BUT...
            </Typography>

            <button
              type="button"
              className=" close"
              style={{
                zIndex: "2",
                position: "absolute",
                top: "15px",
                right: "15px",
              }}
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <span aria-hidden="true">
                <Image
                  src="/images/community/modal-close.svg"
                  width="18px"
                  height="18px"
                  alt="modal close image"
                />
              </span>
            </button>
          </Box>
          <Box sx={nftLandingCss.modalBody}>
            <Typography variant="span" style={{ color: "black" }}>
              Your reaction was not added because there are too many reactions
              on this message.
            </Typography>
          </Box>

          <Button
            variant="contained"
            sx={nftLandingCss.okeybtnCSS}
            onClick={() => setShow(false)}
          >
            Okay
          </Button>
        </Box>
      </Modal>
    </div>
  );
};
export default CommunityMessageList;
